<template>
    <div class="archived-courses">
        <ag-table :data-source-api="getAllArchivedCourses" :grid-options="gridOptions" :permissions="{}" :rtl="false"
        :is-entities-response="false" />
        <tm-popup :title="coursePopupTitle" ref="coursePopup">
            <div class="vx-row justify-start">
                <div class="vx-col w-full mb-2 mt-2">
                    <tm-input class="w-full" name="اسم الفرصة التدريبية" placeholder="اسم الفرصة التدريبية" type="text" v-model="course.name" readonly="true"/>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
                    <tm-select class="w-full" :options="getCourseTypesOptions" label="name"
                    name="النوع" :reduce="(course) => course.value" v-model="course.type" :disabled="true"/>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
                    <tm-input class="w-full" name="عدد المقاعد" placeholder="عدد المقاعد" type="number" v-model="course.totalSeats" readonly="true"/>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
                    <tm-input class="w-full" name="من تاريخ" placeholder="من تاريخ" type="date" v-model="course.startDate" readonly="true"/>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
                    <tm-input class="w-full" name="إلى تاريخ" placeholder="إلى تاريخ" type="date" v-model="course.endDate" readonly="true"/>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
                    <tm-input class="w-full" name="من الساعة" placeholder="من الساعة" type="time" v-model="course.startTime" readonly="true"/>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
                    <tm-input class="w-full" name="إلى الساعة" placeholder="إلى الساعة" type="time" v-model="course.endTime" readonly="true"/>
                </div>
                <div class="vx-col w-full mb-2 mt-2">
                    <tm-input class="w-full" name="الرابط" placeholder="الرابط" type="text" v-model="course.registrationFormUrl" readonly="true" />
                </div>
                <div class="vx-col w-full mb-2 mt-4">
                    <p class="mt-2 px-2" style="font-size: smaller">الوصف</p>
                <tm-text-area class="w-full" name="الوصف" v-model="course.description" readonly="true"/>
                </div>
            </div>
        </tm-popup>
    </div>
    
</template>

<script>
import { RepositoryFactory } from "../volunteer-repositories/volunteerRepositoryFactory";
import AgTable from "../../shared/shared-components/ag-grid/AgTableServerSide.vue";
import AgTableBtnCell from "../../shared/shared-components/ag-grid/AgTableBtnCell";
import utilities from "@/app/shared/utilities/index";
import TmPopup from "@/app/shared/shared-components/TmPopup";
import TmInput from "@/app/shared/shared-components/TmInput";
import TmTextArea from "@/app/shared/shared-components/TmTextArea";
import TmSelect from "@/app/shared/shared-components/TmSelect";

const coursesRepo = RepositoryFactory.get("coursesRepository");

export default {
    name: "ArchivedCourses",
    components: {
        AgTable,
        // eslint-disable-next-line vue/no-unused-components
        AgTableBtnCell,
        TmPopup,
        TmInput,
        TmTextArea,
        TmSelect,
    },
    data() {
        return {
        gridApi: null,
        gridOptions: null,
        coursePopupTitle: 'معلومات الفرصة التدريبية',
        status: {
            pending: "قيد الانتظار",
            in_progress: "قيد التنفيذ",
            completed: "تم التنفيذ",
            finished: "مكتمل",
        },
        courseTypes: {
            zadi_session: "جلسة زادي",
            training_course: "كورس تدريبي",
        },
        course: {
            name: null,
            description: null,
            type: null,
            startDate: null,
            endDate: null,
            startTime: null,
            endTime: null,
            totalSeats: null,
            registrationFormUrl: null,
            status: 'pending'
        },
        };
    },
    methods: {
        createColDefs() {
        let self = this;
        return [
            {
            headerName: "المعرف",
            field: "id",
            sortable: true,
            width: 200,
            },
            {
            headerName: "الفرصة التدريبية",
            field: "name",
            filter: "agTextColumnFilter",
            width: 210,
            sortable: false,
            },
            {
            headerName: "الوصف",
            field: "description",
            filter: "agTextColumnFilter",
            width: 210,
            sortable: false,
            },
            {
            headerName: "من تاريخ",
            field: "startDate",
            filter: "agDateColumnFilter",
            width: 200,
            sortable: false,
            valueGetter: function getObject(data) {
                return data.data.startDate ? utilities.formatDate(data.data.startDate, "yyyy-MM-DD") : '-';
            },
            },
            {
            headerName: "إلى تاريخ",
            field: "endDate",
            filter: "agDateColumnFilter",
            width: 200,
            sortable: false,
            valueGetter: function getObject(data) {
                return data.data.endDate ? utilities.formatDate(data.data.endDate, "yyyy-MM-DD") : '-';
            },
            },
            {
            headerName: "الحالة",
            field: "status",
            width: 210,
            sortable: false,
            valueGetter: function getObject(params) {
                return self.status[params.data.status] || "-";
            },
            filter: "agSetColumnFilter",
            filterParams: {
                values: Object.keys(self.status),
                valueFormatter: (params) =>
                self.status[params.value] || params.value,
            },
            },
            {
            headerName: "النوع",
            field: "type",
            width: 210,
            sortable: false,
            valueGetter: function getObject(params) {
                return self.courseTypes[params.data.type] || "-";
            },
            },
            {
            headerName: "عدد المقاعد",
            field: "totalSeats",
            width: 210,
            sortable: false,
            },
            {
                headerName: "الإجراءات",
                cellRendererFramework: AgTableBtnCell,
                sortable: false,
                valueGetter: function getObject(params) {
                    return params.data;
                },
                cellRendererParams: {
                    repeatRecord: function (course) {
                        self.onRepeatCourse(course);
                    },
                    viewRecordDetails: function (course) {
                        self.onViewCourse(course);
                    },
                    actions: ["repeat", "view"],
                    permissions: self.permissions,
                },
            },
        ];
        },
        async getAllArchivedCourses(query) {
            return await coursesRepo.fetchCourses(`${query}&filter=status||$eq||finished&filter=type||$eq||training_course`);
        },
        async onRepeatCourse(course) {
            await coursesRepo.repeatCourse(course.id);
            await this.$router.push({
                path: `/volunteers/courses`,
            });
        },
        onViewCourse(course) {
            Object.assign(this.course, {
                ...course,
                startDate: utilities.formatDate(course.startDate, "yyyy-MM-DD"),
                endDate: utilities.formatDate(course.endDate, "yyyy-MM-DD"),
            });
            this.$refs.coursePopup.open();
        },
    },
    created() {
        this.gridOptions = {};
        this.gridOptions.columnDefs = this.createColDefs();
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    },
    computed: {
        getCourseTypesOptions() {
        return Object.keys(this.courseTypes).map(key => ({
            name: this.courseTypes[key],
            value: key
        }));
        },
    },
};
</script>
